// extracted by mini-css-extract-plugin
export default {"button":"ButtonToTop_button__H002+","arrow":"ButtonToTop_arrow__V4rg+"};